/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2024, Zumper
 */

import type { History } from 'history'
import type { LinkProps } from 'react-router-dom'

export function locationDescriptorToString(
  ...[descriptor, ...rest]:
    | [
        descriptor: undefined,
        createHref: History<unknown>['createHref'],
        location: History<unknown>['location'],
      ]
    | [descriptor: undefined, history: Pick<History<unknown>, 'createHref' | 'location'>]
): undefined
export function locationDescriptorToString(
  ...[descriptor, ...rest]:
    | [
        descriptor: LinkProps<unknown>['to'],
        createHref: History<unknown>['createHref'],
        location: History<unknown>['location'],
      ]
    | [
        descriptor: LinkProps<unknown>['to'],
        history: Pick<History<unknown>, 'createHref' | 'location'>,
      ]
): string
export function locationDescriptorToString(
  ...[descriptor, ...rest]:
    | [
        descriptor: LinkProps<unknown>['to'] | undefined,
        createHref: History<unknown>['createHref'],
        location: History<unknown>['location'],
      ]
    | [
        descriptor: LinkProps<unknown>['to'] | undefined,
        history: Pick<History<unknown>, 'createHref' | 'location'>,
      ]
): string | undefined
export function locationDescriptorToString(
  ...[descriptor, ...rest]:
    | [
        descriptor: LinkProps<unknown>['to'] | undefined,
        createHref: History<unknown>['createHref'],
        location: History<unknown>['location'],
      ]
    | [
        descriptor: LinkProps<unknown>['to'] | undefined,
        history: Pick<History<unknown>, 'createHref' | 'location'>,
      ]
): string | undefined {
  const createHref = rest.length === 1 ? rest[0].createHref : rest[0]
  const location = rest.length === 1 ? rest[0].location : rest[1]

  const _href = typeof descriptor === 'function' ? descriptor(location) : descriptor
  return _href && typeof _href === 'object' ? createHref(_href) : _href
}
